import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "data-panel" }
const _hoisted_2 = {
  key: 0,
  style: {"color":"#9ca3af","font-size":"14px"}
}
const _hoisted_3 = { class: "data-bar-wrap" }
const _hoisted_4 = { class: "data-bar-label" }
const _hoisted_5 = {
  key: 0,
  class: "data-breakdown"
}
const _hoisted_6 = { class: "data-settings" }
const _hoisted_7 = { class: "data-field" }
const _hoisted_8 = { class: "data-field" }
const _hoisted_9 = {
  key: 0,
  class: "data-error"
}
const _hoisted_10 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[6] || (_cache[6] = _createElementVNode("h3", { class: "data-title" }, "Armazenamento", -1)),
    (!$setup.detail)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, "Carregando..."))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", {
              class: "data-bar-fill",
              style: _normalizeStyle({ width: Math.min(100, ($setup.detail.usedMb / $setup.detail.storageLimitMb) * 100) + '%', background: $setup.storageColor($setup.detail.usedMb, $setup.detail.storageLimitMb) })
            }, null, 4)
          ]),
          _createElementVNode("p", _hoisted_4, _toDisplayString($setup.formatMb($setup.detail.usedMb)) + " usados de " + _toDisplayString($setup.formatMb($setup.detail.storageLimitMb)) + " (" + _toDisplayString(Math.round(($setup.detail.usedMb / $setup.detail.storageLimitMb) * 100)) + "%)", 1),
          ($setup.breakdownItems.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.breakdownItems, (item) => {
                  return (_openBlock(), _createElementBlock("span", {
                    key: item.key,
                    class: "data-bd-item"
                  }, [
                    _createElementVNode("span", {
                      class: "data-bd-dot",
                      style: _normalizeStyle({ background: item.color })
                    }, null, 4),
                    _createTextVNode(_toDisplayString(item.label) + ": " + _toDisplayString($setup.formatMb(item.mb)), 1)
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_6, [
            _cache[5] || (_cache[5] = _createElementVNode("h4", { class: "data-settings-title" }, "Configurações", -1)),
            _createElementVNode("div", _hoisted_7, [
              _cache[3] || (_cache[3] = _createElementVNode("label", null, "Limite de armazenamento (MB)", -1)),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.editStorageLimitMb) = $event)),
                type: "number",
                min: "100",
                step: "100"
              }, null, 512), [
                [
                  _vModelText,
                  $setup.editStorageLimitMb,
                  void 0,
                  { number: true }
                ]
              ])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _cache[4] || (_cache[4] = _createElementVNode("label", null, "Data de renovação anual", -1)),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.editRenewalDate) = $event)),
                type: "date"
              }, null, 512), [
                [_vModelText, $setup.editRenewalDate]
              ])
            ]),
            ($setup.saveError)
              ? (_openBlock(), _createElementBlock("p", _hoisted_9, _toDisplayString($setup.saveError), 1))
              : _createCommentVNode("", true),
            _createElementVNode("button", {
              class: "btn-admin-primary",
              type: "button",
              disabled: $setup.saving,
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => ($setup.saveSettings && $setup.saveSettings(...args)))
            }, _toDisplayString($setup.saving ? 'Salvando...' : 'Salvar configurações'), 9, _hoisted_10)
          ])
        ], 64))
  ]))
}